module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "course-name req-name"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), (_vm.req.advanced) ? _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours: " + _vm._s(_vm.req.credits))]) : _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours: " + _vm._s(_vm.req.course.minimum_credits))]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Minimum Grade: " + _vm._s(_vm.req.minimum_grade))]), _vm._v(" "), (_vm.req.advanced) ? _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Attempts: " + _vm._s(_vm.req.attempts))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.req.course.description) ? _c('div', {
    staticClass: "course-description"
  }, [_vm._v("\n      Course Description: " + _vm._s(_vm.req.course.description) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.req.course.prereq) ? _c('div', {
    staticClass: "course-prereq"
  }, [_vm._v("\n      Prerequisites:\n      "), _c('requisites-string', {
    attrs: {
      "operand": _vm.req.course.prereq,
      "requisiteType": "prereq"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.req.course.coreq) ? _c('div', {
    staticClass: "course-coreq"
  }, [_vm._v("\n      Corequisites:\n      "), _c('requisites-string', {
    attrs: {
      "operand": _vm.req.course.coreq,
      "requisiteType": "coreq"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b70e963","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course_requirement.vue
// module id = 1115
// module chunks = 1